import React, { Suspense, useState } from "react";
import { SuspenseImg } from "../../helpers/SuspenseImg";
import Slider from "react-slick";
import { CONSTANTS } from "../../helpers/Constant";
import ArkenLogo from "../../assets/portfolio/public/arken.svg";
import skolanalysisLogo from "../../assets/portfolio/public/skolanalysis.svg";

import Image_01 from "../../assets/portfolio/public/arken-01.png";
import Image_02 from "../../assets/portfolio/public/arken-02.png";

import Image_03 from "../../assets/portfolio/public/skolanalysis-01.png";
import Image_04 from "../../assets/portfolio/public/skolanalysis-02.png";
import Image_05 from "../../assets/portfolio/public/skolanalysis-03.png";
import Spinner from "../misc/spinner";
import Back from "../Icons/Back";

const Public = (props) => {
  const types = ["Arken", "Skolanalysis"];

  const [active, setActive] = useState(types[0]);

  const settings = {
    dots: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      {" "}
      <div className="bg-Gray-50 py-8 md:px-10 px-5 flex flex-row fixed items-center left-0 top-0 fixed-header z-50">
        <Back
          className="cursor-pointer text-Gray-600 md:hidden block"
          width="24"
          onClick={props.closeModalLayout}
        />
        {/* <span className="text-lightGray-800 font-avenirHeavy text-base px-5 hidden md:block">
          Public sector
        </span> */}
        {types.map((type) => (
          <span
            className={`px-3 inline-block text-lightGray-800 font-avenirBook py-2 text-sm cursor-pointer ${
              active === type ? "active-tab" : ""
            }`}
            key={type}
            active={active === type}
            onClick={() => setActive(type)}
          >
            {type}
          </span>
        ))}
      </div>
      <div className="px-14 py-10 mt-16">
        <>
          {active === "Arken" ? (
            <>
              <div className="mb-5 ">
                <img src={ArkenLogo} alt="" title="" />
              </div>
              <div className="md:w-8/12 mx-auto w-full">
                <Slider {...settings}>
                  <div>
                    <Suspense
                      fallback={
                        <div className="spinner-view">
                          <Spinner />
                        </div>
                      }
                    >
                      <SuspenseImg alt="" src={Image_01} />
                    </Suspense>
                  </div>
                  <div>
                    <Suspense
                      fallback={
                        <div className="spinner-view">
                          <Spinner />
                        </div>
                      }
                    >
                      <SuspenseImg alt="" src={Image_02} />
                    </Suspense>
                  </div>
                </Slider>
                <div className="grid md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-12 py-12  mt-6">
                  <div>
                    <h3 className="text-3xl text-blue-800 font-medium">
                      Background
                    </h3>
                    <p className="pt-6 leading-relaxed text-Gray-600">
                      At {CONSTANTS.COMPANY_NAME}, we are on the lookout for
                      enthusiastic tech savvy individuals who want to make a
                      great difference in their fields. IT consultants play a
                      vital role by acting strategically as multi-faced and
                      dynamic hands-on specialists to resolve client issues.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-3xl text-blue-800 font-medium">
                      Objectives
                    </h3>
                    <p className="pt-6 leading-relaxed text-Gray-600">
                      Design a responsive space tourism website that not only
                      informs the user of the mission and astronaut process, but
                      also is visually captivating and futuristic
                    </p>
                  </div>
                </div>
                <div className="grid md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-12 py-12">
                  <div>
                    <h3 className="text-3xl text-blue-800 font-medium">Role</h3>
                    <p className="pt-6 leading-relaxed text-Gray-600">
                      Research, UX, UI
                    </p>
                  </div>
                  <div>
                    <h3 className="text-3xl text-blue-800 font-medium">
                      Scope
                    </h3>
                    <p className="pt-6 leading-relaxed text-Gray-600">
                      156 hours <br /> Self-started project
                    </p>
                  </div>
                </div>
                <div className="">
                  <h3 className="text-3xl text-blue-800 font-medium">
                    Research
                  </h3>
                  <p className="pt-6 leading-relaxed text-Gray-600">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </p>
                  <p className="pt-6 leading-relaxed text-Gray-600 text-xs">
                    Sed ut perspiciatis unde omnis iste natus error sit
                    voluptatem accusantium doloremque laudantium, totam rem
                    aperiam, eaque ipsa quae ab illo inventore veritatis et
                    quasi architecto beatae vitae dicta sunt explicabo. Nemo
                    enim ipsam voluptatem quia voluptas sit aspernatur aut odit
                    aut fugit, sed quia consequuntur magni dolores eos qui
                    ratione voluptatem sequi nesciunt. Neque porro quisquam est,
                    qui dolorem ipsum quia dolor sit amet, consectetur, adipisci
                    velit, sed quia non numquam eius modi tempora incidunt ut
                    labore et dolore magnam aliquam quaerat voluptatem. Ut enim
                    ad minima veniam, quis nostrum exercitationem ullam corporis
                    suscipit laboriosam, nisi ut aliquid ex ea commodi
                    consequatur
                  </p>
                </div>
                <div className="grid md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-12 py-12">
                  <div>
                    <h3 className="text-3xl text-blue-800 pb-4">
                      Topic Research
                    </h3>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Cras mattis nisi nec orci aliquam commodo.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Vestibulum id sapien rutrum, finibus e id sapien rutrum,
                      finibus enim vitanim vitae, placerat urna.{" "}
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Nulla molestie neque at est mollis, ut tris id sapien
                      rutrum, finibus enim vitatique nulla malesuada.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Cras in risus cursus, volutpat qu id sapien rutrum,
                      finibus enim vitaam quis, posuere libero.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Praesent euismod odio et lectus tempor placerat.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Cras convallis nisi nec justo vestibul id sapien rutrum,
                      finibus enim vitaum, sed molestie justo rutrum.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-3xl text-blue-800 pb-4">
                      Competitive Analysis
                    </h3>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Cras mattis nisi nec orci aliquam commodo.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Vestibulum id sapien rutrum, finibus e id sapien rutrum,
                      finibus enim vitanim vitae, placerat urna.{" "}
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Nulla molestie neque at est mollis, ut tris id sapien
                      rutrum, finibus enim vitatique nulla malesuada.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Cras in risus cursus, volutpat qu id sapien rutrum,
                      finibus enim vitaam quis, posuere libero.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Praesent euismod odio et lectus tempor placerat.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Cras convallis nisi nec justo vestibul id sapien rutrum,
                      finibus enim vitaum, sed molestie justo rutrum.
                    </p>
                  </div>
                </div>
              </div>
            </>
          ) : null}
          {active === "Skolanalysis" ? (
            <>
              <div className="mb-5 ">
                <img src={skolanalysisLogo} alt="" title="" />
              </div>
              <div className="md:w-8/12 mx-auto w-full">
                <Slider {...settings}>
                  <div>
                    <Suspense
                      fallback={
                        <div className="spinner-view">
                          <Spinner />
                        </div>
                      }
                    >
                      <SuspenseImg alt="" src={Image_03} />
                    </Suspense>
                  </div>
                  <div>
                    <Suspense
                      fallback={
                        <div className="spinner-view">
                          <Spinner />
                        </div>
                      }
                    >
                      <SuspenseImg alt="" src={Image_04} />
                    </Suspense>
                  </div>
                  <div>
                    <Suspense
                      fallback={
                        <div className="spinner-view">
                          <Spinner />
                        </div>
                      }
                    >
                      <SuspenseImg alt="" src={Image_05} />
                    </Suspense>
                  </div>
                </Slider>
                <div className="grid md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-12 py-12">
                  <div>
                    <h3 className="text-3xl text-blue-800 font-medium">
                      Background
                    </h3>
                    <p className="pt-6 leading-relaxed text-Gray-600">
                      At {CONSTANTS.COMPANY_NAME}, we are on the lookout for
                      enthusiastic tech savvy individuals who want to make a
                      great difference in their fields. IT consultants play a
                      vital role by acting strategically as multi-faced and
                      dynamic hands-on specialists to resolve client issues.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-3xl text-blue-800 font-medium">
                      Objectives
                    </h3>
                    <p className="pt-6 leading-relaxed text-Gray-600">
                      Design a responsive space tourism website that not only
                      informs the user of the mission and astronaut process, but
                      also is visually captivating and futuristic
                    </p>
                  </div>
                </div>
                <div className="grid md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-12 py-12">
                  <div>
                    <h3 className="text-3xl text-blue-800 font-medium">Role</h3>
                    <p className="pt-6 leading-relaxed text-Gray-600">
                      Research, UX, UI
                    </p>
                  </div>
                  <div>
                    <h3 className="text-3xl text-blue-800 font-medium">
                      Scope
                    </h3>
                    <p className="pt-6 leading-relaxed text-Gray-600">
                      156 hours <br /> Self-started project
                    </p>
                  </div>
                </div>
                <div className="">
                  <h3 className="text-3xl text-blue-800 font-medium">
                    Research
                  </h3>
                  <p className="pt-6 leading-relaxed text-Gray-600">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </p>
                  <p className="pt-6 leading-relaxed text-Gray-600 text-xs">
                    Sed ut perspiciatis unde omnis iste natus error sit
                    voluptatem accusantium doloremque laudantium, totam rem
                    aperiam, eaque ipsa quae ab illo inventore veritatis et
                    quasi architecto beatae vitae dicta sunt explicabo. Nemo
                    enim ipsam voluptatem quia voluptas sit aspernatur aut odit
                    aut fugit, sed quia consequuntur magni dolores eos qui
                    ratione voluptatem sequi nesciunt. Neque porro quisquam est,
                    qui dolorem ipsum quia dolor sit amet, consectetur, adipisci
                    velit, sed quia non numquam eius modi tempora incidunt ut
                    labore et dolore magnam aliquam quaerat voluptatem. Ut enim
                    ad minima veniam, quis nostrum exercitationem ullam corporis
                    suscipit laboriosam, nisi ut aliquid ex ea commodi
                    consequatur
                  </p>
                </div>
                <div className="grid md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-12 py-12">
                  <div>
                    <h3 className="text-3xl text-blue-800 pb-4">
                      Topic Research
                    </h3>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Cras mattis nisi nec orci aliquam commodo.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Vestibulum id sapien rutrum, finibus e id sapien rutrum,
                      finibus enim vitanim vitae, placerat urna.{" "}
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Nulla molestie neque at est mollis, ut tris id sapien
                      rutrum, finibus enim vitatique nulla malesuada.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Cras in risus cursus, volutpat qu id sapien rutrum,
                      finibus enim vitaam quis, posuere libero.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Praesent euismod odio et lectus tempor placerat.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Cras convallis nisi nec justo vestibul id sapien rutrum,
                      finibus enim vitaum, sed molestie justo rutrum.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-3xl text-blue-800 pb-4">
                      Competitive Analysis
                    </h3>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Cras mattis nisi nec orci aliquam commodo.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Vestibulum id sapien rutrum, finibus e id sapien rutrum,
                      finibus enim vitanim vitae, placerat urna.{" "}
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Nulla molestie neque at est mollis, ut tris id sapien
                      rutrum, finibus enim vitatique nulla malesuada.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Cras in risus cursus, volutpat qu id sapien rutrum,
                      finibus enim vitaam quis, posuere libero.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Praesent euismod odio et lectus tempor placerat.
                    </p>
                    <p className="py-2 leading-relaxed text-Gray-600 text-xs">
                      Cras convallis nisi nec justo vestibul id sapien rutrum,
                      finibus enim vitaum, sed molestie justo rutrum.
                    </p>
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </>
      </div>
    </>
  );
};

export default Public;
